import axios from 'axios'
import qs from 'qs'

const state = () => ({
  loaded: false,
  items: [],
  currentPage: 1,
  itemsPerPage: 9,
  numberOfPages: 1,
  numberOfTotalItems: 9
})

const getters = {
  getParams: (state, getters, rootState) => {
    const params = {
      currentPage: state.currentPage,
      itemsPerPage: state.itemsPerPage
    }
    if (rootState.categories.selected !== '-1') {
      params.category = {
        equals: rootState.categories.selected
      }
    }
    if (rootState.locations.selected !== '-1') {
      params.location = {
        equals: rootState.locations.selected
      }
    }
    if (rootState.industries.selected !== '-1') {
      params.industry = {
        equals: rootState.industries.selected
      }
    }
    if (rootState.dateTimeIntervals.selected.from !== '' && rootState.dateTimeIntervals.selected.to !== '') {
      params.dateTimeFrom = {
        greaterThanOrEqual: rootState.dateTimeIntervals.selected.from
      }
      params.dateTimeTo = {
        lessThanOrEqual: rootState.dateTimeIntervals.selected.to
      }
    }
    return params
  }
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setItems (state, payload) {
    state.items = [...payload]
  },
  addItems (state, payload) {
    state.items = [...state.items, ...payload]
  },
  resetCurrentPage (state) {
    state.currentPage = 1
  },
  increaseCurrentPage (state) {
    state.currentPage += 1
  },
  setNumberOfPages (state, payload) {
    state.numberOfPages = payload
  },
  setNumberOfTotalItems (state, payload) {
    state.numberOfTotalItems = payload
  }
}

const actions = {
  async get ({ state, commit, getters }) {
    commit('setLoaded', false)
    try {
      const response = await axios.get(window.app.appointment_list.api_base + 'appointments/?' + qs.stringify(getters.getParams))
      state.currentPage === 1
        ? commit('setItems', response.data.appointments)
        : commit('addItems', response.data.appointments)
      commit('setNumberOfPages', response.data.numberOfPages)
      commit('setNumberOfTotalItems', response.data.numberOfTotalItems)
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
